import React from "react";
import { Outlet } from "react-router";
import Header from "../components/Header";
import { TimeTrackerProvider } from "../context/timeTrackerContext";

const ProtectedRouteLayout = ({ headerVisible = true }) => {
  return (
    <TimeTrackerProvider>
      {headerVisible && <Header />}
      <Outlet />
    </TimeTrackerProvider>
  );
};

export default ProtectedRouteLayout;
